export function LoginWithTokenController(
    $window,
    $stateParams,
    AuthenticationError,
    loginWithTokenResult,
    SessionStorageCacheService,
    BASE_PATH_PUBLIC,
    IS_LOCALHOST,
    HYBRID_LOCALHOST
) {
    function initialize() {
        SessionStorageCacheService.clear();
        // Clear resource string data for the domain after being redirected from global signin
        window.localStorage.removeItem('rss-data');
        window.localStorage.removeItem('rss-last-requested');
        window.localStorage.removeItem('last-resource-string-request');

        if (loginWithTokenResult.success) {
            let redirectUrl = loginWithTokenResult.data.RedirectUrl;
            
            if (IS_LOCALHOST) {
                // Since [api/auth/loginWithToken] could return a 'redirectUrl' with '/manager/app' or '/manager/public',
                // we'll trim the mount path and provide a different localhost if needed.
                const isPublicAppRedirect = redirectUrl.substring(0, 12).toLowerCase() === '/manager/pub';
                const isAuthenticatedAppRedirect = redirectUrl.substring(0, 12).toLowerCase() === '/manager/app';
                const authenticatedAppBaseUrl = `https://${HYBRID_LOCALHOST}`;

                if (isPublicAppRedirect) {
                    // trim and use the current location's localhost
                    redirectUrl = `${redirectUrl.slice(15)}`;
                } else if (isAuthenticatedAppRedirect) {
                    const relativeRedirectPath = `${redirectUrl.slice(12)}`;
                    const authenticatedAppRedirectUrl = new URL(relativeRedirectPath, authenticatedAppBaseUrl).href;
                    redirectUrl = authenticatedAppRedirectUrl;
                } else {
                    // don't modify 'redirectUrl'
                }
            }

            $window.location.href = redirectUrl;
        } else if (loginWithTokenResult.errorCode === 227 || loginWithTokenResult.errorCode === 225) {
            // If the token is invalid we send the user back to the login page.
            const queryObj = {};

            const returnUrl = $stateParams.returnUrl || $stateParams.ReturnUrl;
            if (returnUrl) {
                queryObj.returnUrl = returnUrl;
            }

            switch (loginWithTokenResult.errorCode) {
                case 227:
                    queryObj.authError = AuthenticationError.InvalidTokenErrorMessage;
                    break;
                case 225:
                    queryObj.authError = AuthenticationError.BlockedUserError;
                    break;
                default:
                    queryObj.authError = AuthenticationError.InvalidTokenErrorMessage;
                    break;
            }
            $window.location.href = `${BASE_PATH_PUBLIC}/authentication/login?authError=${queryObj.authError}&returnUrl=${queryObj.returnUrl}`;
        }
    }

    initialize();
}

LoginWithTokenController.$inject = [
    '$window',
    '$stateParams',
    'AuthenticationError',
    'loginWithTokenResult',
    'SessionStorageCacheService',
    'BASE_PATH_PUBLIC',
    'IS_LOCALHOST',
    'HYBRID_LOCALHOST'
];
